import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["spliced", "inline"];
import * as React from 'react';
import cx from 'classnames';
import * as styles from './styles/group.css';
/**
 * Компонента для объединения нескольких ControlButton горизонтальную группу
 */
export function ControlButtonGroup(_ref) {
  var spliced = _ref.spliced,
    inline = _ref.inline,
    divProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
    className: cx(styles['control-button-group'], spliced && styles['spliced'], inline && styles['inline'])
  }));
}